import { createContext } from 'react';
import { GetServerSidePropsSettings } from '../types/global';

interface AppContextType {
  settings?: GetServerSidePropsSettings;
}

export const AppContext = createContext<AppContextType>({});
